import React from 'react'
import { compose, pure } from 'recompose'

import './IndexAddCell.css'

const IndexAddCell = () => (
  <div styleName="index-add-cell">
    <p>
      次の問題を
      <br />
      追加する
    </p>
  </div>
)

export default compose(pure)(IndexAddCell)
